// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn-rect {
  position: relative;
  overflow: hidden;
  padding: 2px;
  border-radius: 5.303px;
  z-index: 1;
  margin-bottom: 10px;
}
.btn-rect::before {
  /* content: "";
   position: absolute;
   top: -1px;
   left: -1px;
   right: -1px;
   bottom: -1px;
   background: conic-gradient(#D70913, #E98019, #F6EB04, #89F140, #3ED684, #3284EE, #DE3CC3,#D70913);
   transform: scaleX(3);
   z-index: -1;
   animation: rotate-gradient 7s linear infinite;*/
}
.btn-rect button, .btn-rect a {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: #2B2B2B;
  border-radius: 5.303px;
  text-decoration: none;
  transition: all 0.3s ease;
  border: none;
  cursor: pointer;
  color: #FFF;
  padding: 15px 20px;
}
.btn-rect button span, .btn-rect a span {
  color: #FFF;
  text-align: center;
  font-family: "Roboto", sans-serif;
  font-size: 9.5px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 1.235px;
}
.btn-rect:hover button, .btn-rect:hover a {
  background: #34ace0;
  color: #000;
}
.btn-rect:hover button span, .btn-rect:hover a span {
  color: #000;
}
.btn-rect:active:not(.active) button, .btn-rect:active:not(.active) a {
  transform: scale(0.9);
}
.btn-rect.active button, .btn-rect.active a {
  background: #34ace0;
  color: #000;
}
.btn-rect.active button span, .btn-rect.active a span {
  color: #000;
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/RectButton/RectButton.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EAGA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,mBAAA;AAHF;AAIE;EACC;;;;;;;;;kDAAA;AAOH;AAIE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAFJ;AAGI;EACE,WAAA;EAEA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;AAFN;AAOI;EACE,mBAAA;EACA,WAAA;AALN;AAMM;EACE,WAAA;AAJR;AASI;EACE,qBAAA;AAPN;AAWI;EACE,mBAAA;EACA,WAAA;AATN;AAUM;EACE,WAAA;AARR","sourcesContent":["@import '../../../styles/_variables';\r\n\r\n.btn-rect{\r\n  position: relative;\r\n // width: 98px;\r\n // height: 49px;\r\n  overflow: hidden;\r\n  padding: 2px;\r\n  border-radius: 5.303px;\r\n  z-index: 1;\r\n  margin-bottom: 10px;\r\n  &::before {\r\n   /* content: \"\";\r\n    position: absolute;\r\n    top: -1px;\r\n    left: -1px;\r\n    right: -1px;\r\n    bottom: -1px;\r\n    background: conic-gradient(#D70913, #E98019, #F6EB04, #89F140, #3ED684, #3284EE, #DE3CC3,#D70913);\r\n    transform: scaleX(3);\r\n    z-index: -1;\r\n    animation: rotate-gradient 7s linear infinite;*/\r\n  }\r\n  button,a{\r\n    position: relative;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: #2B2B2B;\r\n    border-radius: 5.303px;\r\n    text-decoration: none;\r\n    transition: all 0.3s ease;\r\n    border:none;\r\n    cursor: pointer;\r\n    color: #FFF;\r\n    padding: 15px 20px;\r\n    span{\r\n      color: #FFF;\r\n\r\n      text-align: center;\r\n      font-family: 'Roboto',sans-serif;\r\n      font-size: 9.5px;\r\n      font-style: normal;\r\n      font-weight: 700;\r\n      line-height: normal;\r\n      letter-spacing: 1.235px;\r\n\r\n    }\r\n  }\r\n  &:hover{\r\n    button,a{\r\n      background: #34ace0;\r\n      color: #000;\r\n      span{\r\n        color: #000;\r\n      }\r\n    }\r\n  }\r\n  &:active:not(.active){\r\n    button,a{\r\n      transform: scale(0.9);\r\n    }\r\n  }\r\n  &.active{\r\n    button,a{\r\n      background: #34ace0;\r\n      color: #000;\r\n      span{\r\n        color: #000;\r\n      }\r\n    }\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
